import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { SunIcon } from "../../components/brand/icons";

export default function DashboardPage() {
  const [summary, setSummary] = useState(null);
  const [sitemapMsg, setSitemapMsg] = useState("");

  useEffect(() => {
    api.get("/admin/summary").then((res) => setSummary(res.data)).catch(() => {});
  }, []);

  const cards = [
    { label: "Exhibitions", value: summary?.exhibitions, to: "/admin/exhibitions" },
    { label: "Press items", value: summary?.press_items, to: "/admin/press" },
    { label: "Enquiries", value: summary?.enquiries, to: "/admin/enquiries" },
    { label: "Users", value: summary?.users, to: "/admin/users" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="h-condensed text-4xl">Dashboard</h1>

      {summary && !summary.active_edition && (
        <p className="mt-6 border border-charcoal bg-stone-40 px-4 py-3 text-sm font-light" data-testid="no-active-edition-note">
          No active edition — the Latest Edition banner is hidden on the home page.{" "}
          <Link to="/admin/editions" className="underline underline-offset-4">Activate one</Link>.
        </p>
      )}

      <div className="mt-10 grid gap-px border border-charcoal bg-charcoal sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} data-testid={`dashboard-card-${c.label.toLowerCase().replace(/\s+/g, "-")}`} className="group bg-offwhite p-6 transition-colors duration-300 hover:bg-stone-40">
            <p className="h-condensed text-4xl">{c.value ?? "—"}</p>
            <p className="eyebrow mt-2 text-[0.65rem]">{c.label}</p>
          </Link>
        ))}
      </div>

      <div className="mt-12 flex flex-wrap items-center gap-6">
        <SunIcon className="h-8 w-8" />
        <button
          type="button"
          data-testid="regenerate-sitemap-button"
          onClick={async () => {
            setSitemapMsg("Working…");
            try {
              const { data } = await api.post("/admin/regenerate-sitemap");
              setSitemapMsg(`Sitemap updated with ${data.count} URLs.`);
            } catch {
              setSitemapMsg("Could not regenerate the sitemap.");
            }
          }}
          className="link-arrow text-xs"
        >
          Regenerate sitemap
        </button>
        {sitemapMsg && <span className="text-xs font-light" data-testid="sitemap-message">{sitemapMsg}</span>}
      </div>
    </div>
  );
}
